// 見積書一覧画面
import {
  Button,
  Checkbox,
  FormControl,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  Grid,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogActions
} from '@material-ui/core';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import 'date-fns';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import '../App.css';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import LoadingComponent from '../components/LoadingComponent';
import PaginationComponent from '../components/PaginationComponent';
import {
  btnColor,
  employeeMasterData,
  workingBudgetsData,
  isLoggedIn,
  mainBlueColor,
  userMenuId,
  userRole
} from '../GlobalState';
import { parsePrice } from '../utils';
import './List.css';
import { BasicSelect } from '../components/parts/input/BasicSelect';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { TWorkingBudget } from '../types/WorkingBudgetList';
import { ItemTableRow } from '../components/workingBudgetList/ItemTableRow';
import { SelectModal } from '../components/workingBudgetList/SelectModal';
import { EventInput, SegHierarchy } from '@fullcalendar/core';
import {
  deleteSelectedWorkingBudget,
  getWorkingBudgetList
} from '../apicalls/WorkingBudgetList';
import { getUserSelectOptions } from '../utils/processAndTaskFormUtils';
import { NOT_LOGGED_IN } from '../const/Const';

// 検索パラメータ
export type SearchParam = {
  // 工事件名
  estimateName?: string;
  // 営業担当者
  salesUserId?: number;
  // 工事番号
  constructCode?: string;
  // 開始見積合計額
  estimateTotalStart?: number;
  // 終了見積合計額
  estimateTotalEnd?: number;
  // 開始見積原価合計金額
  estimateCostTotalStart?: number;
  // 終了見積原価合計金額
  estimateCostTotalEnd?: number;
  // 開始追加原価
  additionalCostStart?: number;
  // 終了追加原価
  additionalCostEnd?: number;
  // 開始最終粗利金額
  finalGrossProfitStart?: number;
  // 終了最終粗利金額
  finalGrossProfitEnd?: number;
  // 開始最終粗利率
  finalGrossProfitMarginStart?: number;
  // 終了最終粗利率
  finalGrossProfitMarginEnd?: number;
  // 開始発注総額
  orderTotalStart?: number;
  // 終了発注総額
  orderTotalEnd?: number;
};

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);

export const WorkingBudgetList: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const matches = useMediaQuery('(min-width:600px)');

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      formControl: {
        minWidth: 120,
        backgroundColor: '#FFFFFF'
      },
      formControl1: {
        minWidth: 120,
        height: 30,
        borderRadius: 5,
        borderWidth: 1,
        paddingLeft: 5
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      },
      main: {
        minWidth: 700
      },
      table: {
        padding: 8,
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontWeight: 'bold',
        fontSize: 16
      },
      input: {
        borderColor: '#CCCCCC',
        padding: 5,
        margin: 10
      },
      table1: {
        // padding: 8,
      },
      topBoxText: {
        fontSize: 14,
        color: '#000000'
      },
      topContainer: {
        display: 'flex',
        paddingBottom: 15,
        justifyContent: 'space-between'
      },
      btnContainer: {
        display: 'flex',
        flexDirection: matches ? 'row' : 'column',
        alignItems: 'center'
      },
      inputBottom: {
        height: 30,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      searchField: {
        overflow: 'hidden',
        width: window.innerWidth,
        display: 'flex',
        flexWrap: 'wrap'
      },
      topList: {
        display: 'flex',
        marginTop: 25,
        marginBottom: 25,
        width: '100%',
        justifyContent: 'flex-start'
      },
      submitButton: {
        backgroundColor: '#007dff',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#2691ff',
          boxShadow: 3
        }
      },
      cancelButton: {
        backgroundColor: '#bdbdbd',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#cccccc',
          boxShadow: 3
        }
      },
      copyStateMessage: {
        // リンクURLコピーの成否メッセージ
        position: 'fixed',
        left: 60,
        bottom: 60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: 300,
        padding: '12px 24px',
        borderRadius: 8,
        color: 'white',
        backgroundColor: 'black',
        fontSize: 14,
        opacity: 0.8
      }
    })
  );

  const matches2 = useMediaQuery('(min-width:960px)');
  const classes = useStyles();
  const history: any = useHistory();

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(
    history.location.state?.currentPage || 1
  );
  const [displayLimit, setDisplayLimit] = useState<number>(10);

  const [openSelectModal, setOpenSelectModal] = useState(false);
  const [orderTotalAmount, setOrderTotalAmount] = useState(0);

  const [workingBudgets, setWorkingBudgets] =
    useRecoilState(workingBudgetsData);
  const [apiData, setApiData] = useState<TWorkingBudget[]>([]);
  const [employeeMasterApiData, setEmployeeMasterApiData] =
    useRecoilState(employeeMasterData);
  const [loading, setLoading] = useState(
    workingBudgets !== null ? false : true
  );
  const [userData, setUserData] = useState<any>(
    employeeMasterApiData !== null ? employeeMasterApiData : []
  );
  const [salesUserId, setSalesUserId] = useState<number>(0);
  const [selectItems, setSelectItems] = useState<number[]>([]);
  const [isAllSelect, setIsAllSelect] = useState<boolean>(false);
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [userPermission] = useRecoilState(userRole);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );
  // 検索パラメータ
  const [searchParam, setSearchParam] = useState<SearchParam>({});
  // 初回マウントフラグ
  const [isMount, setIsMount] = useState<boolean>(false);

  const [userMenu] = useRecoilState<any>(userMenuId);

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    if (isMount) return;
    searchWorkingBudget('init');
    setIsMount(true);
  }, []);

  useEffect(() => {
    let total = 0;
    apiData.map(item => {
      total += item.order_total;
    });
    setOrderTotalAmount(total);
  }, [apiData]);

  useEffect(() => {
    searchWorkingBudget('search');
  }, [currentPage, displayLimit, searchParam]);

  // 検索欄テキスト系入力イベント
  const handleInputSearchParam = (event: EventInput) => {
    setSearchParam({
      ...searchParam,
      [event.target.name as string]: event.target.value
    });
  };

  // 検索欄数値系入力イベント
  const handleNumberInputSearchParam = (e: EventInput) => {
    const inputVal = e.target.value.replace(/[^0-9]/g, '');
    if (parseInt(inputVal)) {
      setSearchParam({
        ...searchParam,
        [e.target.name as string]: inputVal
      });
    } else {
      setSearchParam({
        ...searchParam,
        [e.target.name as string]: null
      });
    }
  };

  // 実行予算検索処理
  const searchWorkingBudget = (mode?: string) => {
    mode == 'init' && setLoading(true);
    getWorkingBudgetList(searchParam, currentPage, displayLimit)
      .then(data => {
        if (data.data === NOT_LOGGED_IN) {
          changeLoggedInData(NOT_LOGGED_IN);
        } else {
          if (typeof data.data === 'string') {
            setErrorMessage(data.data);
            setOpen(true);
          } else {
            if (data.workingBudgets_list) {
              setApiData(data.workingBudgets_list.working_budgets_list);
              setPageCount(data.workingBudgets_list.page_count);
            }
          }
        }
      })
      .finally(() => mode == 'init' && setLoading(false));
  };

  const onClickDelete = () => {
    setLoading(true);
    deleteSelectedWorkingBudget(selectItems)
      .then(() => {
        searchWorkingBudget('delete');
      })
      .finally(() => setLoading(false));
    setOpenAlert(false);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleClickOpenAlert = () => {
    if (userPermission !== 1) {
      setErrorMessage('削除の権限がありません。');
      setOpen(true);
    } else {
      setOpenAlert(true);
    }
  };

  if (loggedIn === NOT_LOGGED_IN) {
    return <Redirect to='/' />;
  }

  if (userMenu == 'Storage') {
    return (
      <Redirect
        to={{
          pathname: '/constructions'
        }}
      />
    );
  }

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <AppBarComponent patternName='estimates' />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>

          <div
            style={{
              display: 'flex',
              flexDirection: matches2 ? 'row' : 'column'
            }}
            className={classes.topList}
          >
            <div
              // 空アイテム
              className='empty-list'
              style={{ width: 15 }}
            ></div>
            <div onClick={() => history.push('/estimates')} className='border2'>
              <div className={classes.topBoxText}>見積書</div>
            </div>
            <div onClick={() => history.push('/invoices')} className='border2'>
              <div className={classes.topBoxText}>請求書</div>
            </div>
            <div
              onClick={() => history.push('/merchandise-orders')}
              className='border2'
            >
              <div className={classes.topBoxText}>商品発注書</div>
            </div>
            <div
              onClick={() => history.push('/outsource-orders')}
              className='border2'
            >
              <div className={classes.topBoxText}>外注発注書</div>
            </div>
            <div
              onClick={() => history.push('/site-contacts')}
              className='border2'
            >
              <div className={classes.topBoxText}>現場連絡表</div>
            </div>
            <div
              className='border2'
              style={{
                backgroundColor: '#F5F5F5',
                borderTopColor: '#0099CB',
                borderBottom: 'none'
              }}
            >
              <div className={classes.topBoxText} style={{ color: '#0099CB' }}>
                実行予算表
              </div>
            </div>
            <div
              // 空アイテム
              className='empty-list'
              style={{ flexGrow: 1 }}
            ></div>
          </div>

          <div
            style={{
              overflow: 'hidden',
              backgroundColor: '#F5F5F5',
              padding: 15
            }}
          >
            <Grid container>
              <Grid item xs={12} className={classes.searchField}>
                <div>
                  <input
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='工事件名'
                    name='estimateName'
                    value={searchParam.estimateName}
                    onChange={handleInputSearchParam}
                  />
                </div>

                <div>
                  <input
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='工事番号'
                    name='constructCode'
                    value={searchParam.constructCode}
                    maxLength={10}
                    onChange={handleInputSearchParam}
                  />
                </div>

                <div>
                  <input
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='見積合計金額'
                    name='estimateTotalStart'
                    value={searchParam.estimateTotalStart ?? ''}
                    onChange={handleNumberInputSearchParam}
                  />
                </div>

                <span style={{ marginRight: '20px', fontSize: '20px' }}>~</span>

                <div>
                  <input
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='見積合計金額'
                    name='estimateTotalEnd'
                    value={searchParam.estimateTotalEnd ?? ''}
                    onChange={handleNumberInputSearchParam}
                  />
                </div>
                <div>
                  <input
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='見積原価合計金額'
                    name='estimateCostTotalStart'
                    value={searchParam.estimateCostTotalStart ?? ''}
                    onChange={handleNumberInputSearchParam}
                  />
                </div>

                <span style={{ marginRight: '20px', fontSize: '20px' }}>~</span>

                <div>
                  <input
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='見積原価合計金額'
                    name='estimateCostTotalEnd'
                    value={searchParam.estimateCostTotalEnd ?? ''}
                    onChange={handleNumberInputSearchParam}
                  />
                </div>
              </Grid>

              <Grid item xs={12} className={classes.searchField}>
                <div>
                  <input
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='追加原価'
                    name='additionalCostStart'
                    value={searchParam.additionalCostStart ?? ''}
                    onChange={handleNumberInputSearchParam}
                  />
                </div>

                <span style={{ marginRight: '20px', fontSize: '20px' }}>~</span>

                <div>
                  <input
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='追加原価'
                    name='additionalCostEnd'
                    value={searchParam.additionalCostEnd ?? ''}
                    onChange={handleNumberInputSearchParam}
                  />
                </div>

                <div>
                  <input
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='最終粗利金額'
                    name='finalGrossProfitStart'
                    value={searchParam.finalGrossProfitStart ?? ''}
                    onChange={handleNumberInputSearchParam}
                  />
                </div>

                <span style={{ marginRight: '20px', fontSize: '20px' }}>~</span>

                <div>
                  <input
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='最終粗利金額'
                    name='finalGrossProfitEnd'
                    value={searchParam.finalGrossProfitEnd ?? ''}
                    onChange={handleNumberInputSearchParam}
                  />
                </div>

                <div
                  style={{ marginRight: 20, marginBottom: 10 }}
                  className='select-div'
                >
                  <div style={{ paddingLeft: 5 }}>
                    <FormControl className={classes.formControl}>
                      <BasicSelect
                        value={salesUserId}
                        onChange={e => {
                          setSalesUserId(parseInt(e.target.value));
                          setSearchParam(searchParam => ({
                            ...searchParam,
                            salesUserId: parseInt(e.target.value)
                          }));
                        }}
                        inputProps={{ 'aria-label': 'age' }}
                        disableUnderline
                      >
                        <option value={0}>営業担当者</option>
                        {getUserSelectOptions(userData)}
                      </BasicSelect>
                    </FormControl>
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} className={classes.searchField}>
                <div>
                  <input
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='最終粗利率'
                    name='finalGrossProfitMarginStart'
                    value={searchParam.finalGrossProfitMarginStart ?? ''}
                    onChange={handleNumberInputSearchParam}
                  />
                </div>

                <span style={{ marginRight: '20px', fontSize: '20px' }}>~</span>

                <div>
                  <input
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='最終粗利率'
                    name='finalGrossProfitMarginEnd'
                    value={searchParam.finalGrossProfitMarginEnd ?? ''}
                    onChange={handleNumberInputSearchParam}
                  />
                </div>

                <div>
                  <input
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='発注総額'
                    name='orderTotalStart'
                    value={searchParam.orderTotalStart ?? ''}
                    onChange={handleNumberInputSearchParam}
                  />
                </div>

                <span style={{ marginRight: '20px', fontSize: '20px' }}>~</span>

                <div>
                  <input
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='発注総額'
                    name='orderTotalEnd'
                    value={searchParam.orderTotalEnd ?? ''}
                    onChange={handleNumberInputSearchParam}
                  />
                </div>
                <div>
                  <Button
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: buttonColor
                    }}
                    variant='contained'
                    color='primary'
                    onClick={() => {
                      searchWorkingBudget();
                    }}
                  >
                    検索
                  </Button>
                </div>
              </Grid>
            </Grid>
          </div>
          <div
            style={{ padding: 15, backgroundColor: '#FFFFFF', borderRadius: 5 }}
          >
            <div className={classes.topContainer}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center'
                }}
              >
                <div
                  style={{
                    backgroundColor: mainColor,
                    padding: 15,
                    width: 150,
                    color: '#ffffff'
                  }}
                  className={classes.topBoxText}
                >
                  発注合計金額(円)
                </div>
                <div
                  style={{
                    color: '#000000',
                    padding: 15,
                    fontSize: 14,
                    fontWeight: 'bold',
                    width: 180,
                    textAlign: 'right'
                  }}
                  className='border1'
                >
                  {parsePrice(orderTotalAmount)}
                </div>
              </div>
            </div>

            <div className={classes.topContainer}>
              <div style={{ fontSize: 20, paddingTop: 12 }}>実行予算一覧</div>
              <div />
              <div className={classes.btnContainer}>
                <div
                  style={{ marginBottom: 10, width: 125 }}
                  className='select-div'
                >
                  <div style={{ paddingLeft: 5 }}>
                    <FormControl className={classes.formControl}>
                      <BasicSelect
                        value={displayLimit}
                        onChange={e => {
                          setCurrentPage(1);
                          setDisplayLimit(parseInt(e.target.value));
                        }}
                        inputProps={{ 'aria-label': 'age' }}
                        disableUnderline
                      >
                        {/* <option value={0}>
                          結果の制限</option> */}
                        <option value={10}>10件</option>
                        <option value={30}>30件</option>
                        <option value={50}>50件</option>
                      </BasicSelect>
                    </FormControl>
                  </div>
                </div>
                <div style={{ width: 50 }}></div>
                {/* 実行予算新規作成はファーストリリーススコープ外
                <CustomTooltip
                  title={tooltipContents.documenCreateNew}
                  placement="top">
                  <Button
                    style={{
                      backgroundColor: buttonColor,
                      marginBottom: 10,
                      marginLeft: 15,

                    }}
                    variant="contained"
                    color="secondary"
                    startIcon={<NoteAddIcon/>}
                    onClick={() => setOpenSelectModal(true)}
                  >
                    新規作成
                  </Button>
                </CustomTooltip> */}
                <SelectModal
                  openSelectModal={openSelectModal}
                  setOpenSelectModal={setOpenSelectModal}
                  changeLoggedInData={changeLoggedInData}
                  setErrorMessage={setErrorMessage}
                  setOpen={setOpen}
                />
                {userPermission === 1 && (
                  <CustomTooltip
                    title={tooltipContents.documenSelectDeletet}
                    placement='top'
                  >
                    <Button
                      style={{
                        backgroundColor: buttonColor,
                        marginLeft: 15,
                        marginBottom: 10
                      }}
                      variant='contained'
                      color='secondary'
                      startIcon={<DeleteIcon />}
                      onClick={() => {
                        if (selectItems.length <= 0) {
                          alert('対象を選択してください。');
                        } else {
                          handleClickOpenAlert();
                        }
                      }}
                    >
                      選択削除
                    </Button>
                  </CustomTooltip>
                )}
              </div>
            </div>

            <TableContainer component={Paper}>
              <Table className={classes.main} aria-label='customized table'>
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      style={{ minWidth: 20 }}
                      className={classes.table}
                      align='center'
                    >
                      <CustomTooltip
                        title={tooltipContents.selectDelete}
                        placement='top'
                      >
                        <Checkbox
                          checked={isAllSelect}
                          onClick={() => {
                            setIsAllSelect(!isAllSelect);
                            if (isAllSelect) {
                              setSelectItems([]);
                            } else {
                              const ids = apiData.map(
                                item => item.working_budget_id
                              );
                              setSelectItems(ids);
                            }
                          }}
                          style={{
                            color: isAllSelect ? buttonColor : '#FFFFFF'
                          }}
                        />
                      </CustomTooltip>
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ minWidth: 100 }}
                      className={classes.table}
                      align='center'
                    >
                      実行予算番号
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ minWidth: 120 }}
                      className={classes.table}
                      align='center'
                    >
                      工事件名
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ minWidth: 300 }}
                      className={classes.table}
                      align='center'
                    >
                      見積合計額
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ minWidth: 160 }}
                      className={classes.table}
                      align='center'
                    >
                      見積原価合計額
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ minWidth: 160 }}
                      className={classes.table}
                      align='center'
                    >
                      追加原価
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ minWidth: 160 }}
                      className={classes.table}
                      align='center'
                    >
                      最終粗利金額
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ minWidth: 100 }}
                      className={classes.table}
                      align='center'
                    >
                      最終粗利率
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ minWidth: 160 }}
                      className={classes.table}
                      align='center'
                    >
                      発注総額
                    </StyledTableCell>
                    {/* <StyledTableCell
                      style={{minWidth: 140}}
                      className={classes.table}
                      align="center"
                    ></StyledTableCell> */}
                    <StyledTableCell
                      style={{ minWidth: 130 }}
                      className={classes.table}
                      align='center'
                    ></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {apiData &&
                    apiData.length > 0 &&
                    apiData.map((row: TWorkingBudget, index: number) => (
                      <ItemTableRow
                        row={row}
                        selectItems={selectItems}
                        setSelectItems={setSelectItems}
                        key={index}
                        searchWorkingBudget={searchWorkingBudget}
                        setLoading={setLoading}
                        currentPage={currentPage}
                      />
                    ))}
                </TableBody>
              </Table>
              {!loading && apiData.length === 0 && (
                <div className={classes.container}>データがありません</div>
              )}
            </TableContainer>
            <PaginationComponent
              page={currentPage}
              pageCount={pageCount}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </div>
      )}
      <Dialog
        open={openAlert}
        onClose={handleCloseAlert}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{'削除しますか？'}</DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseAlert} color='primary'>
            キャンセル
          </Button>
          <Button onClick={onClickDelete} color='primary' autoFocus>
            削除
          </Button>
        </DialogActions>
      </Dialog>
      <FooterComponent />
    </div>
  );
};
